import React, { Component } from "react";

// import Logo from "./assets/logo.png";
import LogoWhite from "../../../assets/logo.png";

class Header extends Component {
  render() {
    return (
      <div className={``}>
        <div className={`header-logo`} />
      </div>
    );
  }
}

export default Header;
